import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { css, keyframes } from '@emotion/react';
var pulseKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  to {\n    box-shadow: 0 0 0 7px rgba(0, 0, 0, 0);\n  }\n"])));
var getPulseColor = function getPulseColor(appearance) {
  switch (appearance) {
    case 'inprogress':
      return "var(--ds-background-information-bold, #0052CC)";
    case 'moved':
      return "var(--ds-background-warning-bold, #FFAB00)";
    case 'new':
      return "var(--ds-background-discovery-bold, #5243AA)";
    case 'removed':
      return "var(--ds-background-danger-bold, #DE350B)";
    case 'success':
      return "var(--ds-background-success-bold, #00875A)";
    case 'default':
    default:
      return "var(--ds-background-neutral-bold, #42526E)";
  }
};
export var getPulseStyles = function getPulseStyles(appearance) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  border-radius: 3px;\n  box-shadow: 0 0 0 0 ", ";\n  animation: ", " 1.45s cubic-bezier(0.5, 0, 0, 1) 3;\n"])), getPulseColor(appearance), pulseKeyframes);
};